import styled from '@emotion/styled';
import { useParams } from 'react-router';
import { CostCalculator } from 'src/components/CostCalculator';
import { CostCalculatorRentTracker } from '../../components/CostCalculator/CostCalculaotorRentTracker';
import { CostCalculatorBuyTracker } from '../../components/CostCalculator/CostCalculatorBuyTracker';

export function CostCalculatorLandingView() {
  const { product } = useParams<{ product?: 'events' | 'tracker-buy' | 'tracker-rent' }>();

  return (
    <Container>
      {(product === 'events' || product == null) && <CostCalculator user={null} isAdmin={false} />}
      {product === 'tracker-buy' && <CostCalculatorBuyTracker />}
      {product === 'tracker-rent' && <CostCalculatorRentTracker />}
    </Container>
  );
}

const Container = styled.div`
  max-width: 720px;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 70px;
  margin-right: auto;
  margin-left: auto;
`;
